import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/salviabioelectronics.webp';
import screenshot_target from '../../../images/letterfunnel/hubertmartens.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Hubert Martens"
      firstname="Hubert"
      companyname="Salvia BioElectronics"
      competition="ShiraTronics en Neurolief"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/hubertmartens.js